import { UntitledIcon } from '@faceup/icons'
import { ulBookmarkMinus } from '@faceup/icons/ulBookmarkMinus'
import { ulDotsHorizontal } from '@faceup/icons/ulDotsHorizontal'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { ReportStatusTag } from '@faceup/report/src/components/ReportStatusTag'
import { Card } from '@faceup/ui'
import { Button, Col, Dropdown, Row, Typography } from '@faceup/ui-base'
import moment from 'moment-timezone'
import type { SavedReport } from '../../../Contexts/SavedReportsProvider'
import { useSavedReportsContext } from '../../../hooks/useSavedReportsContext'

const messages = defineMessages('followUp.pages.checkReportList.components.reportInfo', [
  { id: 'unlist', defaultMessage: 'Unlist' },
] as const)

type ReportInfoProps = {
  report: SavedReport
  onClick: () => void
}

export const ReportInfo = (props: ReportInfoProps) => {
  const { report, onClick } = props
  const { removeReport } = useSavedReportsContext()

  return (
    <Card onClick={onClick}>
      <Row justify='space-between' className='mb-2'>
        <Col>
          <Typography.Text className='inline-flex'>
            <ReportStatusTag color={report.status.color} name={report.status.name} />
          </Typography.Text>
        </Col>
        <Col>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'unlist',
                  label: <FormattedMessage message={messages.unlist} />,
                  icon: <UntitledIcon icon={ulBookmarkMinus} />,
                  onClick: () => removeReport(report),
                },
              ],
            }}
          >
            <Button type='link' size='small' onClick={e => e.stopPropagation()}>
              <UntitledIcon icon={ulDotsHorizontal} />
            </Button>
          </Dropdown>
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col span={24}>
          <Typography.Title level={5} className='font-bold'>
            {report.category}
          </Typography.Title>
          <Typography.Text className='text-prussianBlue-600'>{report.content}</Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Text className='text-prussianBlue-600 font-semibold'>
            {moment(report.createdAt).format('LLL')}
          </Typography.Text>
        </Col>
      </Row>
    </Card>
  )
}
